<template>
  <div>
    <div class="box mt-20">
      <div class="box-header">
        <h4>출입자 정보 확인</h4>
        <small>출입 요청 정보를 확인해 주세요.</small>
      </div>
      <div class="box-body">
        <div class="form-group row">
          <label class="col-2 form-control-label">
            <span class="">출입자</span>
          </label>
          <div class="col-10 pt-2">
            <visitor-table :items="visitorList"/>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 form-control-label">
            <span class="">출입일시</span>
          </label>
          <div class="col-6 pt-2">
            {{getDueDate(visitorList[0].fromDate, visitorList[0].toDate)}}
          </div>
        </div>
      </div>
    </div>


    <div class="box mt-20">
      <div class="box-header">
        <!-- <h3>선택정보 입력</h3> -->

        <h4>입실 전 확인사항</h4>
        <!-- <p>차량정보, 기타 요청사항을 입력하세요</p> -->
        <small>입실 전 아래 항목을 반드시 확인해주세요.</small>
      </div>

      <div class="box-body pt-0">
        <div class="box-tbl mt-0">
          <table class="tbl no-outline no-shadow">
            <colgroup>
              <col width="42px">
              <col width="auto">
            </colgroup>
            <thead>
            <tr>
              <th>
                <!--<label class="md-check">-->
                  <!--<input type="checkbox" class="has-value">-->
                  <!--<i class="blue"></i>-->
                <!--</label>-->
              </th>
              <th>내용</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in checkList">
              <td>
                <label class="md-check">
                  <input type="checkbox" class="has-value" v-model="checkedList" :value="item.index">
                  <i class="blue"></i>
                </label>
              </td>
              <td>{{ item.contents }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <div class="btn-wrap mt-30 justify-content-center">
      <button class="btn btn-lg line-2" @click="prev()" ><i class="icon-arrow-line-left mr-5"></i>이전</button>
      <button class="btn btn-lg blue" @click="save()" :disabled="complete">완료<i class="icon-check ml-5"></i></button>
    </div>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import AssetTable from './AssetTable.vue'
import VisitorTable from './VisitorTable.vue'

export default {
  props: {
    visitorList: { type: Object, default: function(){ return {}}},
  },
  components: { VisitorTable ,DateRangePicker},
  data() {
    return {
      saveApi: 'visitor/apply',
      complete: true,
      checkList: null,
      checkedList: [],
    }
  },
  watch:{
    checkedList: function(oldVal, newVal){

      if(!this.checkList) return;

      if(this.checkedList.length == this.checkList.length) {
        this.complete=false;
      }
    }
  },
  computed: {
    getDate(){
      return (date) =>{
        return moment(date).format(this.dateFormat);
      }
    }
  },
  mounted(){
    this.getCheckList();
  },
  methods: {
    prev(){
      var query = Object.assign({},this.$route.query);
      this.$router.push({ path: '/app/main/inputInfo', query: query})
    },
    save(){
      this.complete = true;
      this.$http.post('/api/public/' + this.saveApi + '/', this.visitorList)
        .then(function(result){
          // this.$toast.success('방문신청 접수가 완료되었습니다.');
          this.noti('접수완료', '방문 신청 접수가 완료되었습니다. </br> 임직원 승인 후 출입 가능합니다.', 'success');
        }.bind(this)).catch((e) =>{
          console.log(e);
          this.complete = false;
      })
    },
    getCheckList(){
      this.$http.get('/api/public/checkList/1')
        .then((result) => {
          this.checkList = result.data;
        }).catch((e) =>{
      })
    },
  }
}
</script>

<style>

</style>
